import React from 'react';
import { FaEnvelope, FaHome, FaPhone } from 'react-icons/fa';
import styles from './Contact.module.css';

const Contact = () => {
  return (
    <section className={styles.container} id="contact">
      <div className={styles.contact}>
        <h2 className={styles.heading}>聯絡我們 Contact Us</h2>
        <div className={styles.detailContainer}>
          <div className={styles.group}>
            <FaHome className={styles.icon} />
            <p className={styles.text}>
              香港灣仔駱克道160-174號 越秀大廈 11樓 1103室
            </p>
          </div>
          <div className={styles.group}>
            <FaPhone className={styles.icon} />
            <p className={styles.text}>2129 5287</p>
          </div>
          <div className={styles.group}>
            <FaEnvelope className={styles.icon} />
            <p className={styles.text}>synergyyouthhk@gmail.com</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
